import { fetch } from "../helpers/httpRequest";
const API_HOST = import.meta.env.VITE_APP_API_HOST;
export const fetchPairList = () => {
    return fetch("GET", `${API_HOST}/orders/v1/order/user/pair_list`, {}, {});
};
export const createOrder = (body) => {
    return fetch(
        "POST",
        `${API_HOST}/orders/v1/order/user/create_order`,
        body,
        {}
    );
};
export const fetchOrderBooks = (body) => {
    return fetch(
        "GET",
        `${API_HOST}/orders/v1/order/user/order_book?pairName=${body.pairName}&limit=${body.limit}`,
        {},
        {}
    );
};
export const fetchMarketTrade = (body) => {
    return fetch(
        "GET",
        `${API_HOST}/orders/v1/order/user/trade?pairName=${body.pairName}&limit=${body.limit}`,
        {},
        {}
    );
};
export const login = (body) => {
    return fetch("POST", `${API_HOST}/orders/v1/order/user/login`, body, {});
};

// SSO login: performs a credentialed fetch to the backend so the browser
// sets the httpOnly auth cookies from the Set-Cookie response header,
// without a full page reload (which would reset Redux state).
export const ssoLogin = (token) => {
    const url = `${API_HOST}/users/v1/user/login?token=${encodeURIComponent(token.trim())}`;
    return window.fetch(url, { method: "GET", credentials: "include" });
};
export const logout = () => {
    return fetch("GET", `${API_HOST}/orders/v1/order/user/logout`, {}, {});
};
export const fetchGraphData = (data) => {
    const url = `${API_HOST}/graph/v1/graph/user/graph_data?interval=${data.interval}&pairName=${data.pairName}&fromDate=${data.fromDate}&toDate=${data.toDate}&limit=${data.limit}`;
    return fetch("GET", url, {}, {});
};
export const fetchNotifications = (offset, limit) => {
    const url = `${API_HOST}/orders/v1/order/user/notifications`;
    return fetch("GET", url, {}, { offset, limit });
};
/** POST body: `{ readAll: true }` or `{ readAll: false, id: number }` */
export const markNotificationsRead = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/notifications/read`;
    return fetch("PUT", url, body, {});
};
export const fetchActivePairBalance = (body) => {
    const params = new URLSearchParams({
        baseCurrency: body.baseCurrency,
        otherCurrency: body.otherCurrency,
    });
    if (body.walletId != null && String(body.walletId).trim() !== '') {
        params.set('walletId', String(body.walletId).trim());
    }
    const url = `${API_HOST}/wallet/v1/get_balance?${params.toString()}`;
    return fetch("GET", url, {}, {});
};

export const fetchLinkedWallets = (symbol) => {
    const encodedSymbol = encodeURIComponent(String(symbol ?? "").trim());
    const url = `${API_HOST}/wallet/v1/wallets/linked?symbol=${encodedSymbol}`;
    return fetch("GET", url, {}, {});
};
export const fetchGasPrice = () => {
    const url = `${API_HOST}/wallet/v1/get_gas_prices`;
    return fetch("GET", url, {}, {});
};
export const fetchEstimatedGasFee = (coin, walletType, amount) => {
    const params = { coin };
    if (walletType) {
        params.walletType = walletType;
    }
    if (amount != null && amount !== '') {
        params.amount = amount;
    }
    const url = `${API_HOST}/wallet/v1/estimated_gas_fee`;
    return fetch("GET", url, {}, params);
};
export const fetchUserOrderList = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/user_order_list`;
    return fetch("GET", url, {}, body);
};
export const cancelOrder = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/cancel_order`;
    return fetch("PUT", url, body, {});
};
export const fetchUserInfo = () => {
    const url = `${API_HOST}/orders/v1/order/user/user_info`;
    return fetch("GET", url, {}, {});
};
export const fetchUserTrades = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/user_trade_list`;
    return fetch("GET", url, {}, body);
};

export const getWalletList = (body) => {
    const url = `${API_HOST}/wallet/v1/get_wallet_list`;
    return fetch("GET", url, {}, body);
};

export const getWalletAssetList = (body, params) => {
    const url = `${API_HOST}/wallet/v1/get_asset_list`
    return fetch("GET", url, {}, params);

};

export const updateWalletStatus = (body) => {
    const url = `${API_HOST}/wallet/v1/change_wallet_status`;
    return fetch("PUT", url, body, {});
};

export const fetchPortfolioBalanceGraph = (params = {}) => {
    const url = `${API_HOST}/wallet/v1/wallet/user/portfolio_balance_graph`;
    return fetch("GET", url, {}, params);
};

export const fetchAssetAllocation = (params = {}) => {
    const url = `${API_HOST}/wallet/v1/wallet/user/asset_allocation`;
    return fetch("GET", url, {}, params);
};

export const fetchAddressWhitelist = (params) => {
    const url = `${API_HOST}/wallet/v1/user/address_whitelist`;
    return fetch("GET", url, {}, params);
};

export const subscribeAddressWhitelist = (body) => {
    const url = `${API_HOST}/wallet/v1/user/address_whitelist`;
    return fetch("POST", url, body, {});
};

export const withdrawWallet = (body) => {
    const url = `${API_HOST}/wallet/v1/user/withdraw`;
    return fetch("POST", url, body, {});
};

export const fetchDepositHistory = (params = {}) => {
    const url = `${API_HOST}/wallet/v1/user/history/deposit`;
    return fetch("GET", url, {}, params);
};

export const fetchWithdrawHistory = (params = {}) => {
    const url = `${API_HOST}/wallet/v1/user/history/withdraw`;
    return fetch("GET", url, {}, params);
};

export const createAlert = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/add_alert`;
    return fetch("POST", url, body, {});
};
export const fetchAlerts = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/fetch_alerts`;
    return fetch("GET", url, {}, body);
};
export const cancelAlert = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/cancel_alert`;
    return fetch("GET", url, {}, body);
};
export const editAlert = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/edit_alert`;
    return fetch("PUT", url, body, {});
};
export const editUserInfo = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/update_user_info`;
    return fetch("PUT", url, body, {});
};
export const getOrderHistory = (body) => {
    const url = `${API_HOST}/orders/v1/order/user/user_order_history`;
    return fetch("GET", url, {}, body);
};
export const layout = (method, body = {}) => {
    const url = `${API_HOST}/orders/v1/order/user/layout`;
    return fetch(method, url, body, {});
};
export const getReport = (body = {}) => {
    const url = `${API_HOST}/orders/v1/order/user/report`;
    return fetch("GET", url, {}, body);
};
export const API = {
    fetchPairList,
    createOrder,
    fetchOrderBooks,
    fetchMarketTrade,
    login,
    ssoLogin,
    logout,
    fetchGraphData,
    fetchNotifications,
    markNotificationsRead,
    fetchActivePairBalance,
    fetchLinkedWallets,
    fetchUserOrderList,
    cancelOrder,
    fetchUserInfo,
    fetchUserTrades,
    getWalletList,
    getWalletAssetList,
    fetchPortfolioBalanceGraph,
    fetchAssetAllocation,
    fetchAddressWhitelist,
    subscribeAddressWhitelist,
    withdrawWallet,
    fetchDepositHistory,
    fetchWithdrawHistory,
    updateWalletStatus,
    createAlert,
    fetchAlerts,
    cancelAlert,
    editAlert,
    editUserInfo,
    getOrderHistory,
    fetchGasPrice,
    fetchEstimatedGasFee,
    layout,
    getReport
};
